import React from "react";
import useAuth from "../hooks/useAuth";

const Content = ({ children }) => {
  const {user} = useAuth()
  return <div className={`content position-relative ${user?.role === 'Root' ? 'pt-5': ''}`}>{children}</div>;
};

export default Content;
